import { render, staticRenderFns } from "./LottieLoader.vue?vue&type=template&id=e1f613e6&scoped=true&"
import script from "./LottieLoader.vue?vue&type=script&lang=js&"
export * from "./LottieLoader.vue?vue&type=script&lang=js&"
import style0 from "./LottieLoader.vue?vue&type=style&index=0&id=e1f613e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f613e6",
  null
  
)

component.options.__file = "LottieLoader.vue"
export default component.exports